// Amada Edit: the rail is a native overflow + snap scroller. This file only
// reads which scene is start-aligned, swaps the product row beneath it, and
// drives the two desktop arrows.
//
// It deliberately does NOT touch the wheel. An earlier version fed deltaY into
// scrollLeft so a plain mouse could move the rail; with five scenes that made
// the section a 2458px scroll trap — the page could not be left, or re-entered
// from below, until the rail had been wound all the way through. Vertical wheel
// belongs to the page, always. Horizontal trackpad deltaX and shift+wheel reach
// the rail natively, touch swipes it, and the arrows cover everything else.
//
// Note that on desktop the page's scroller is .page-wrapper, not the document:
// base.css gives html/body `height: 100dvh; overflow: hidden` above 990px. So
// "let the wheel through" means letting it reach that element. Nothing here
// needs to know which one it is, which is the point of not intercepting it.
//
// Scroll targets are measured from live geometry rather than offsetLeft, which
// is relative to the offsetParent (.page-width-narrow, not the rail) and lands
// every jump one page-margin past its snap point.

(function () {
  function init(root) {
    var rail = root.querySelector('[data-lookbook-scenes]');
    if (!rail) return;

    var scenes = Array.prototype.slice.call(root.querySelectorAll('[data-lookbook-scene]'));
    var sets = Array.prototype.slice.call(root.querySelectorAll('[data-lookbook-set]'));
    var prev = root.querySelector('[data-lookbook-prev]');
    var next = root.querySelector('[data-lookbook-next]');

    if (scenes.length < 2) return;

    var current = -1;
    var frame = null;
    var settleTimer = null;

    function maxScroll() {
      return Math.max(0, rail.scrollWidth - rail.clientWidth);
    }

    // Where scrollLeft must land for `scene` to sit flush against the rail's
    // start edge, clamped to what the scrollport can actually reach.
    function offsetOf(scene) {
      var delta = scene.getBoundingClientRect().left - rail.getBoundingClientRect().left;
      return Math.max(0, Math.min(rail.scrollLeft + delta, maxScroll()));
    }

    function show(index) {
      if (index === current || index < 0 || index >= scenes.length) return;
      current = index;

      sets.forEach(function (set) {
        set.hidden = Number(set.dataset.lookbookSet) !== index;
      });
    }

    function nearest() {
      var origin = rail.getBoundingClientRect().left;
      var bestIndex = 0;
      var bestDistance = Infinity;

      scenes.forEach(function (scene, i) {
        var distance = Math.abs(scene.getBoundingClientRect().left - origin);
        if (distance < bestDistance) {
          bestDistance = distance;
          bestIndex = i;
        }
      });

      return bestIndex;
    }

    // Read the scrollport, not the scene index: an arrow is only live while
    // there is somewhere left to go. This is what stops a dead arrow ever being
    // drawn over a rail that already fits.
    function applyArrows(left) {
      var max = maxScroll();
      if (prev) prev.disabled = left <= 1;
      if (next) next.disabled = max <= 1 || left >= max - 1;
    }

    function updateArrows() {
      applyArrows(rail.scrollLeft);
    }

    function measure() {
      show(nearest());
      updateArrows();
    }

    function sync() {
      if (!frame) {
        frame = requestAnimationFrame(function () {
          frame = null;
          measure();
        });
      }
      clearTimeout(settleTimer);
      settleTimer = setTimeout(measure, 140);
    }

    rail.addEventListener('scroll', sync, { passive: true });
    window.addEventListener('resize', sync);

    if ('onscrollend' in window) {
      rail.addEventListener('scrollend', measure, { passive: true });
    }

    function go(step) {
      var index = nearest() + step;
      var target = scenes[index];
      if (!target) return;

      var left = offsetOf(target);
      rail.scrollTo({ left: left, behavior: 'smooth' });

      // Apply the destination now rather than waiting for the scroll handler:
      // the product row should change on the press, not once a 400ms smooth
      // scroll has settled. The handler still runs and has the final say if the
      // scroll is interrupted mid-flight.
      show(index);
      applyArrows(left);
    }

    if (prev) {
      prev.addEventListener('click', function () {
        go(-1);
      });
    }

    if (next) {
      next.addEventListener('click', function () {
        go(1);
      });
    }

    measure();
  }

  function boot() {
    document.querySelectorAll('[data-lookbook]').forEach(function (root) {
      init(root.closest('.amada-lookbook') || root);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
